// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IMxQ","rootMobile":"styles_rootMobile__1NtGD"};